import React from "react";
import NotificationsContent from "@/components/domains/notifications/NotificationsContent";

export default function NotificationsPage() {
  return (
    <div className="space-y-4 sm:space-y-6 relative z-10 bg-white rounded-lg p-5 shadow-sm border border-gray-200">
      <NotificationsContent />
    </div>
  );
}
